import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthOrRedirect } from "./components/auth/redirect";
// Import build tool generated manifest file
import arbManifest from "../public/translations/arbManifest";
import {
  createAsyncMessageBundleManager,
  LocalizationContextBuilder,
} from "@amzn/arb-tools";
import { MbmProvider } from "@amzn/react-arb-tools";
import * as Cookie from "js-cookie";

const userDefinedLocale = Cookie.get("hvh-locale");
const DEFAULT_LOCALE = "en-US";
const selectedLocale =
  userDefinedLocale && userDefinedLocale.length > 0
    ? userDefinedLocale
    : DEFAULT_LOCALE;

// Define a localization context provider
const localizationContextProvider = () =>
  new LocalizationContextBuilder()
    .withLocale(selectedLocale)
    .withDefaultLocale("en-US")
    .build();

const mbm = createAsyncMessageBundleManager({
  arbManifest,
  localizationContextProvider,
  resolveBundleUrl: (url: string | undefined) =>
    url
      ? "/checklist/translations/" + url
      : "/checklist/translations/translation.json",
});

ReactDOM.render(
  <MbmProvider mbm={mbm}>
    <React.StrictMode>
      <AuthOrRedirect>
        <App />
      </AuthOrRedirect>
    </React.StrictMode>
  </MbmProvider>,
  document.getElementById("ASHContentRoot")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
